<template>
  <v-col cols="12" class="pl-6 pt-8">
    <v-row align="center">
      <v-textarea
        v-model="Val"
        placeholder=" "
        rows="3"
        v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.Val = `${this.Val || ''} ${text}`;}, 'form_examination_remarks')}"
        v-on:click="() => {this.$vtt.setModel('form_examination_remarks');}"
        @input="setHint(Val, (replacement) => { Val = replacement })"
        @keydown.tab="(e) => {
          if (!getReplacement(Val)) { return true; } else { e.preventDefault(); Val = getReplacement(Val); clearReplacement(); }
        }"
      >
        <template v-slot:label>
          <span style="font-size: 21px;">Others⁄Remarks</span>
        </template>
      </v-textarea>
    </v-row>
  </v-col>
</template>

<script>
  import textreplacementmixin from '../../../../../mixins/textreplacementmixin';
  export default {
    name: 'FormExaminationRemark',

    mixins: [textreplacementmixin],

    props: {
      value: { type: String, default: '' }
    },

    data() { 
      return {
          Val: this.value
      }
    },

    watch: {
      value(val) {
        this.Val = val
      },
      Val(val) {
        this.$emit('input', val)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>